/**
 * MethodVO contains data for a given shader object for the use within a single material.
 * This allows shader methods to be shared across materials while their non-public state differs.
 */
var ChunkVO = (function () {
    function ChunkVO() {
    }
    return ChunkVO;
}());
export { ChunkVO };



// WEBPACK FOOTER //
// ../dist/lib/data/ChunkVO.js